module.exports = __webpack_public_path__ + "img/exclimation-gem.751bb51d.svg";